// Custom static backend for i18next that loads translation files directly
import enTranslations from './public/locales/en/translation.json';
import ptBRTranslations from './public/locales/pt-BR/translation.json';

// Static translations object
const translations = {
  en: {
    translation: enTranslations,
  },
  'pt-BR': {
    translation: ptBRTranslations,
  },
};

class StaticBackend {
  constructor(services, backendOptions = {}) {
    this.init(services, backendOptions);
  }

  init(services, backendOptions = {}) {
    this.services = services;
    this.options = backendOptions;
  }

  read(language, namespace, callback) {
    try {
      // Check if we have the requested language and namespace
      if (translations[language] && translations[language][namespace]) {
        // Return the static translation data
        callback(null, translations[language][namespace]);
      } else {
        // Return error if translation not found
        callback(new Error(`Translation not found for ${language}/${namespace}`), null);
      }
    } catch (error) {
      callback(error, null);
    }
  }

  // Required method for i18next backend interface
  type = 'backend';
}

// Static method required by i18next
StaticBackend.type = 'backend';

export default StaticBackend;
